const ufeApi = require('services/api/ufeApi');


// https://jira.sephora.com/wiki/display/ILLUMINATE/Remove+BI+Reward+from+Basket+API


function removeBiRewardFromBasket(orderId, skuId) {
    let url = '/api/bi/orders/' + orderId +
              '/rewards/' + skuId +
              '?includeBasket=true';
    return ufeApi.makeRequest(url, {
        method: 'DELETE'
    }).then(data => data.errorCode ? Promise.reject(data) : data);
}


module.exports = removeBiRewardFromBasket;
